import React from 'react';
import { Spring, animated } from 'react-spring';
import styled from 'styled-components';

const Notice = styled.div`
  padding-top: 2rem;
  text-align: center;
  font-weight: ${({ weight }) => weight || 'normal'};
`;

export default ({ children }) => (
  <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
    {animation => (
      <animated.div style={animation}>
        <Notice>{children}</Notice>
      </animated.div>
    )}
  </Spring>
);
